
module.exports = { 
      attributes: {},
    
      body: "Health screening services help reduce ill health and deaths from cancer. There are many types of screening services including:\n\n- Breast\n- Cervical\n- Bowel\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/health-screening-services.md"},
     }